import {DressageProtocolCategory} from "./DressageProtocolCategory";

export default class DressageProtocolListItem {
  constructor(private readonly  _id: string,
              private readonly _category: DressageProtocolCategory,
              private readonly _horse: boolean,
              private readonly _series: string,
              private readonly _protocolNumber: string,
              private readonly _period?: string) {
  }

  get id(): string {
    return this._id;
  }

  get category(): string {
    return this._category;
  }

  get horse(): boolean {
    return this._horse;
  }

  get period(): string | undefined {
    return this._period;
  }

  get series(): string {
    return this._series;
  }

  get protocolNumber(): string {
    return this._protocolNumber;
  }
}
